module.exports = __webpack_public_path__ + "static/media/member-guide2.82ed6949.png";